<markant-icon-button
  [attr.id]="widgetId | concat: '_' : cartridgeId"
  class="icon-button"
  icon="m_context-menu"
  colorScheme="dark"
  id="open-widget-menu"
  data-cy="open-widget-menu"
  (click)="togglePopover($event)"
>
</markant-icon-button>

<markant-platform-modal-bridge>
  <markant-popover
    id="widget-menu-popover"
    data-cy="widget-menu-popover"
    class="container"
    [for]="widgetId | concat: '_' : cartridgeId"
    placement="bottom-end"
    (backdrop)="closePopover()"
    [visible]="showPopover"
  >
    <markant-list class="menu-overlay" (click)="$event.stopPropagation()">
      <markant-list-item
        class="delete-context"
        text="{{ 'dashboard.context.removeWidget' | transloco }}"
        tabindex="1"
        data-markant-close
        (click)="removeWidget()"
      >
        <markant-icon
          class="markant-delete-icon"
          slot="markant-list-item-leading"
          icon="m_trash"
        ></markant-icon>
      </markant-list-item>
    </markant-list>
  </markant-popover>
</markant-platform-modal-bridge>
